import * as React from "react";
import {
  CoreRouterContextContainer,
  CoreRouterContextShape,
} from "./CoreRouterContext";

export const useRouter = (): CoreRouterContextShape =>
  React.useContext(CoreRouterContextContainer);
